import { TagsInput } from '@mantine/core';
import inputClasses from '../input.module.css';
import { defaultInputProps } from '../default-props';
// TODO input margin for small size  doesn't look good, need to fix it
export const tagsInputProps = TagsInput.extend({
    classNames: inputClasses,
    defaultProps: defaultInputProps,
});
